import React from 'react';
import { string, bool, shape } from 'prop-types';

export default function BlogTile({ item, featured, algolia }) {
    return (
        <a href={item.url} className={`c-tile c-blog-tile ${featured ? 'featured' : ''}`}>
            <div className="tile-container">
                <div className="tile-image">
                    <div className="aspect-image">
                        <img src={item.imgUrl} alt={item.title} />
                    </div>
                </div>
                <div className="tile-heading">
                    <p className="date">{item.date}</p>
                    <h4>{item.title}</h4>
                    <p className="hashtag">{item.hashtag}</p>
                    {(featured || algolia) &&
                        <p className="summary">{item.paragraph}</p>
                    }
                    {(featured || algolia) &&
                        <h5>Read more</h5>
                    }
                </div>
            </div>
        </a>
    );
}

BlogTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        imgUrl: string.isRequired,
        date: string.isRequired,
        title: string.isRequired,
        hashtag: string,
        paragraph: string,
        url: string.isRequired
    }).isRequired,
    featured: bool.isRequired,
    algolia: bool
    /* eslint-enable react/no-typos */
};

BlogTile.defaultProps = { algolia: false };



// WEBPACK FOOTER //
// ./src/components/tiles/BlogTile.jsx